// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"No-z","badgeLink":"Oo-z","category":"Po-z"};